<template>
<div>
    <nav class="mx-4 border-b border-gray-dark md:flex md:justify-between md:items-end">
        <h2 class="md:w-1/4 font-bold text-xl px-4 py-4">Settings</h2>
        <nav class="md:w-2/4 md:text-center uppercase text-xs pb-4">
            <a href="#vip" @click.prevent="onNav('vip')" class="p-4" :class="hasNav('vip') ? 'border-primary border-b-2 font-bold text-primary' : ''">VIP</a>
            <a href="#delivery" @click.prevent="onNav('delivery')" class="p-4" :class="hasNav('delivery') ? 'border-primary border-b-2 font-bold text-primary' : ''">Delivery Slots</a>
        </nav>
        <div class="md:w-1/4"></div>
    </nav>
    <keep-alive>
        <div :is="component"></div>
    </keep-alive>
</div>
</template>

<script>
export default {
    data() {
        return {
            active               : 'vip'
        }
    },
    mounted() {
        window.addEventListener('popstate', (event) => {
            if (event.state) {
                this.setNav(event.state.url.slice(1)); // .slice(1) removes the leading '#'
            } else this.navigateUsingURL();
        });

        this.navigateUsingURL();
    },
    computed: {
        component() {
            switch (this.active) {
                case 'vip':
                    return 'settings-vip';
                    break;
                
                case 'delivery':
                    return 'settings-delivery';
                    break;
                
                default:
                    break;
            }
        }
    },
    methods: {
        navigateUsingURL() {
            if (!window.location.hash) {
                // Shows the default.
                this.onNav(this.active);
            } else {
                this.onNav(window.location.hash.slice(1)); // .slice(1) removes the leading '#'
            }
        },
        onNav(to) {
            var stateObject = {'url' : `#${to}`};

            if (window.location.hash && stateObject.url !== window.location.hash) {
                window.history.pushState(stateObject, document.title, window.location.pathname + stateObject.url);
            } else {
                window.history.replaceState(stateObject, document.title, window.location.pathname + stateObject.url);
            }

            this.setNav(to);
        },
        setNav(to) {
            this.active = to;
        },
        hasNav(active) {
            return this.active === active;
        }
    }
}
</script>

<style>

</style>